import { Injectable } from '@angular/core';
import { AppHost } from 'lib-host-interface';
import { TESS_CONSTANTS } from '../constants/tess.constants';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  appHostInitialized = false;
  initializing = false;
  constructor(private appHost: AppHost) {}

  log(message: any, level = TESS_CONSTANTS.defaultLogLevel, logToConsole = true) {
    if (logToConsole) {
      console.log(message);
    }
    if (this.appHostInitialized) {
      this.appHost.logging.log(level, message, TESS_CONSTANTS.appName);
    } else {
      this.initializeAppHost().then((_) => this.appHost.logging.log(level, message, TESS_CONSTANTS.appName));
    }
  }

  private initializeAppHost(): Promise<any> {
    if (this.appHostInitialized) {
      return new Promise((_) => true);
    }
    return this.appHost.next().then((_) => (this.appHostInitialized = true));
  }
}
